'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'staff-snake';
var width = 384;
var height = 512;
var aliases = ["rod-asclepius","rod-snake","staff-aesculapius"];
var unicode = 'e579';
var svgPathData = 'M208 48l56 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-8 0 0-32 8 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-56 0 0 224 32 0c44.2 0 80 35.8 80 80 0 38.7-27.5 71-64 78.4l0-33.1c18.6-6.6 32-24.4 32-45.3 0-26.5-21.5-48-48-48l-32 0 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-96-40 0c-39.8 0-72-32.2-72-72 0-37.1 28-67.6 64-71.6l0 32.4c-18.3 3.7-32 19.8-32 39.2 0 22.1 17.9 40 40 40l40 0 0-224-48 0 0 32c0 35.3-28.7 64-64 64S0 147.3 0 112 28.7 48 64 48l112 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zM96 80L64 80c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32l0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStaffSnake = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;